//@ts-ignore
import { PROBLEM_TYPES } from '@yandex-int/k-common/constants';
import { LessonProblem } from '@yandex-int/k-common/typings';
import { Edit } from 'education-icons';
import get from 'lodash/get';
import { Button, Link, SimpleText, useIntl } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions as lessonActions } from 'common.components/lesson';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { LessonProblemToInsert } from 'common.components/lesson/typings';

import { SidePanelControlTypeProps } from '../typings';

interface Props extends SidePanelControlTypeProps {
    canAddProblemById: boolean;
}

export const SidePanelControlsTypeAddProblemById = React.memo((props: Props) => {
    const { canAddProblemById, notifyCanBeRender, notifyCanNotBeRender } = props;
    const dispatch = useDispatch();
    const intl = useIntl();
    const lesson = useSelector(lessonSelectors.getLesson);

    if (!canAddProblemById) {
        notifyCanNotBeRender();
        return null;
    }

    notifyCanBeRender();

    const addProblemById = () => {
        // eslint-disable-next-line no-alert
        const userInput = prompt(intl.formatMessage({ id: 'lessonEditor.enterProblemId' }));

        if (!userInput) {
            return;
        }

        const problemId = parseInt(userInput, 10);

        if (isNaN(problemId)) {
            return;
        }

        const problems: Array<LessonProblem> = get(lesson, 'problems', []);

        // не даем добавить повторную задачу/теорию
        if (problems.some((item) => item.problem?.id === problemId)) {
            // eslint-disable-next-line no-alert
            alert(intl.formatMessage({ id: 'lessonEditor.problemIdAlreadyExists' }));
            return;
        }

        const entityId = { id: problemId };

        const problemObj: LessonProblemToInsert = {
            type: PROBLEM_TYPES.PROBLEM,
            problem: entityId,
        };

        dispatch(
            lessonActions.insertProblems({
                index: problems.length,
                problems: [problemObj],
            })
        );
        dispatch(lessonActions.saveLesson());
    };

    return (
        <Link key="addProblemById" mix="qa_add-problem-by-id" onClick={addProblemById} pseudo>
            <Button accent={Button.ACCENT.NORMAL} icon={<Edit />} view={Button.VIEW.CLEAR}>
                <SimpleText id="lessonEditor.addProblemById" />
            </Button>
        </Link>
    );
});
